import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import Typography from '@material-ui/core/Typography';
import { Button, TextField, Box, Tabs, Tab, Switch, Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, InputLabel, FormControl, Checkbox, FormControlLabel, ListItemText, CircularProgress } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { styled } from '@material-ui/styles';
import { useHistory, useParams } from "react-router-dom";
import { MaterialReactTable } from 'material-react-table';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";

const ColorButtonBlue = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'darkblue',
        color: 'white',
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default function EditarPessoaInteresse() {
    const history = useHistory();
    const { id } = useParams();
    
    const [loading, setLoading] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    
    // Dados Pessoais
    const [nome, setNome] = useState('');
    const [cpf, setCpf] = useState('');
    const [endereco, setEndereco] = useState('');
    const [fotoBase64, setFotoBase64] = useState('');
    const [horarioInicio, setHorarioInicio] = useState('00:00');
    const [horarioFim, setHorarioFim] = useState('23:59');
    const [status, setStatus] = useState(1);
    const [permissaoMestre, setPermissaoMestre] = useState(false);
    
    // Global Days Schedule (used if permissaoMestre = true)
    const initialDays = [
        { name: "Segunda", key: "segunda", active: false, start: "08:00", end: "18:00" },
        { name: "Terça", key: "terca", active: false, start: "08:00", end: "18:00" },
        { name: "Quarta", key: "quarta", active: false, start: "08:00", end: "18:00" },
        { name: "Quinta", key: "quinta", active: false, start: "08:00", end: "18:00" },
        { name: "Sexta", key: "sexta", active: false, start: "08:00", end: "18:00" },
        { name: "Sábado", key: "sabado", active: false, start: "08:00", end: "18:00" },
        { name: "Domingo", key: "domingo", active: false, start: "08:00", end: "18:00" }
    ];
    const [diasSemana, setDiasSemana] = useState([...initialDays]);

    // Vinculos
    const [vinculos, setVinculos] = useState([]);
    const [todasInstalacoes, setTodasInstalacoes] = useState([]);
    
    // Modals
    const [modalAddOpen, setModalAddOpen] = useState(false);
    const [modalEditOpen, setModalEditOpen] = useState(false);
    const [instalacoesSelecionadas, setInstalacoesSelecionadas] = useState([]);
    const [instalacoesCache, setInstalacoesCache] = useState([]);
    const [loadingInstalacoes, setLoadingInstalacoes] = useState(false);
    const [diasModal, setDiasModal] = useState([...initialDays]);
    const [vinculoEditando, setVinculoEditando] = useState(null);

    useEffect(() => {
        carregarPessoa();
        carregarVinculos();
    }, [id]);

    const handlePesquisarInstalacoes = async (termo) => {
        if (!termo || termo.length < 4) {
           
        }
        setLoadingInstalacoes(true);
        try {
            const token = Cookies.get('token');
            const resp = await api.get(`v1/protected/cliente/instalacoes/buscar/${encodeURIComponent(termo)}`, { headers: { Authorization: "Bearer " + token }});
            
            const novas = resp.data;
            const novoCache = [...instalacoesCache];
            novas.forEach(inst => {
                if (!novoCache.find(c => c.id_instalacao === inst.id_instalacao)) {
                    novoCache.push(inst);
                }
            });
            setInstalacoesCache(novoCache);
            setTodasInstalacoes(novas);
        } catch(e) {
            console.error(e);
        }
        setLoadingInstalacoes(false);
    };

    const carregarVinculos = async () => {
        const token = Cookies.get('token');
        try {
            const resp = await api.get(`/v1/protected/pessoas-interesse/${id}/instalacoes`, { headers: { Authorization: "Bearer " + token }});
            setVinculos(resp.data);
        } catch(e) {
            console.error(e);
        }
    };

    const carregarPessoa = async () => {
        const token = Cookies.get('token');
        try {
            const resp = await api.get(`/v1/protected/pessoas-interesse/buscar/${id}`, { headers: { Authorization: "Bearer " + token }});
            const p = resp.data;
            setNome(p.nome || '');
            setCpf(p.cpf || '');
            setEndereco(p.endereco || '');
            setHorarioInicio(p.horario_padrao_inicio || '00:00');
            setHorarioFim(p.horario_padrao_fim || '23:59');
            setStatus(p.status);
            setPermissaoMestre(p.permissao_mestre === 1);
            
            if (p.horarios_dias_semana) {
                try {
                    const parsed = JSON.parse(p.horarios_dias_semana);
                    const loadedDays = initialDays.map(dia => {
                        const dayData = parsed[dia.key];
                        if (dayData) {
                            return { ...dia, active: dayData.ativo, start: dayData.inicio, end: dayData.fim };
                        }
                        return dia;
                    });
                    setDiasSemana(loadedDays);
                } catch(e) {}
            }
            
            try {
                const fotoResp = await api.get(`/v1/protected/pessoas-interesse/foto/${id}`, { headers: { Authorization: "Bearer " + token }});
                if (fotoResp.data && fotoResp.data.foto_base64) {
                    setFotoBase64(fotoResp.data.foto_base64);
                }
            } catch(e) {}
        } catch(e) {
            console.error(e);
        }
    };

    const handleSalvarPessoa = async () => {
        setLoading(true);
        const token = Cookies.get('token');
        
        const horariosJson = {};
        diasSemana.forEach(dia => {
            horariosJson[dia.key] = { ativo: dia.active, inicio: dia.start, fim: dia.end };
        });

        const payload = {
            nome, 
            cpf, 
            endereco, 
            foto_facial_criptografada: fotoBase64, 
            status, 
            horario_padrao_inicio: horarioInicio, 
            horario_padrao_fim: horarioFim,
            permissao_mestre: permissaoMestre ? 1 : 0,
            horarios_dias_semana: JSON.stringify(horariosJson)
        };

        try {
            await api.put(`/v1/protected/pessoas-interesse/editar/${id}`, payload, { headers: { Authorization: "Bearer " + token }});
            alert("Dados salvos com sucesso!");
        } catch (error) {
            console.error(error);
            alert("Erro ao salvar.");
        }
        setLoading(false);
    };

    const handleAdicionarLote = async () => {
        if(instalacoesSelecionadas.length === 0) {
            alert("Selecione pelo menos uma instalação.");
            return;
        }
        
        const token = Cookies.get('token');
        const horariosJson = {};
        diasModal.forEach(dia => {
            horariosJson[dia.key] = { ativo: dia.active, inicio: dia.start, fim: dia.end };
        });

        const payload = {
            instalacoesIds: instalacoesSelecionadas.map(v => v.id_instalacao),
            horarios_dias_semana: JSON.stringify(horariosJson)
        };
        
        try {
            await api.post(`/v1/protected/pessoas-interesse/${id}/adicionar-instalacoes-lote`, payload, { headers: { Authorization: "Bearer " + token }});
            setModalAddOpen(false);
            carregarVinculos();
            alert("Instalações vinculadas com sucesso!");
        } catch(e) {
            console.error(e);
            alert("Erro ao vincular instalações. " + (e.response?.data || ''));
        }
    };

    const handleSalvarEdicaoVinculo = async () => {
        if(!vinculoEditando) return;
        
        const token = Cookies.get('token');
        const horariosJson = {};
        diasModal.forEach(dia => {
            horariosJson[dia.key] = { ativo: dia.active, inicio: dia.start, fim: dia.end };
        });

        const payload = {
            horarios_dias_semana: JSON.stringify(horariosJson)
        };
        
        try {
            await api.put(`/v1/protected/pessoas-interesse/${id}/editar-instalacao/${vinculoEditando.id_vinculo}`, payload, { headers: { Authorization: "Bearer " + token }});
            setModalEditOpen(false);
            carregarVinculos();
            alert("Vínculo atualizado com sucesso!");
        } catch(e) {
            console.error(e);
            alert("Erro ao editar vínculo. " + (e.response?.data || ''));
        }
    };

    const handleRemoverVinculo = async (idVinculo) => {
        if(!window.confirm("Deseja remover o acesso a esta instalação?")) return;
        const token = Cookies.get('token');
        try {
            await api.delete(`/v1/protected/pessoas-interesse/remover-instalacao/${idVinculo}`, { headers: { Authorization: "Bearer " + token }});
            carregarVinculos();
        } catch(e) {
            console.error(e);
        }
    };

    const openEditModal = (rowOriginal) => {
        setVinculoEditando(rowOriginal);
        let loadedDays = [...initialDays];
        if (rowOriginal.horarios_dias_semana) {
            try {
                const parsed = JSON.parse(rowOriginal.horarios_dias_semana);
                loadedDays = initialDays.map(dia => {
                    const dayData = parsed[dia.key];
                    if (dayData) {
                        return { ...dia, active: dayData.ativo, start: dayData.inicio, end: dayData.fim };
                    }
                    return dia;
                });
            } catch(e) {}
        }
        setDiasModal(loadedDays);
        setModalEditOpen(true);
    };

    const openAddModal = () => {
        setInstalacoesSelecionadas([]);
        setDiasModal([...initialDays]);
        setModalAddOpen(true);
    };

    const colunasVinculos = useMemo(() => [
        { accessorKey: 'instalacao.nome_fantasia', header: 'Instalação' },
        {
            header: 'Ações',
            Cell: ({row}) => (
                <Box display="flex" gap={1}>
                    <Button color="primary" variant="outlined" size="small" onClick={() => openEditModal(row.original)}>Editar Horários</Button>
                    <Button color="secondary" variant="outlined" size="small" onClick={() => handleRemoverVinculo(row.original.id_vinculo)}>Remover Acesso</Button>
                </Box>
            )
        }
    ], []);

    const renderGridDias = (estadoDias, setterDias) => {
        const handleChange = (index, field, value) => {
            const novos = [...estadoDias];
            novos[index][field] = value;
            setterDias(novos);
        };
        
        return estadoDias.map((dia, index) => (
            <Box key={dia.key} display="flex" alignItems="center" gap={2} mb={2}>
                <div style={{ width: '130px' }}>
                    <FormControlLabel
                        control={<Switch color="primary" checked={dia.active} onChange={(e) => handleChange(index, 'active', e.target.checked)} />}
                        label={dia.name}
                    />
                </div>
                <TextField label="Início" type="time" variant="outlined" size="small" disabled={!dia.active} InputLabelProps={{ shrink: true }} value={dia.start} onChange={(e) => handleChange(index, 'start', e.target.value)} />
                <TextField label="Fim" type="time" variant="outlined" size="small" disabled={!dia.active} InputLabelProps={{ shrink: true }} value={dia.end} onChange={(e) => handleChange(index, 'end', e.target.value)} />
            </Box>
        ));
    };

    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
            <NavegadorGestao BaseDados="marcado" PessoasInteresse="marcado" />

            <Grid item xs={12} sm={10} style={{ padding: '20px' }}>
                <Typography variant="h4" style={{ marginBottom: '20px' }}>
                    Editar Pessoa de Interesse: {nome}
                </Typography>

                <Tabs value={tabIndex} onChange={(e, val) => setTabIndex(val)} indicatorColor="primary" textColor="primary">
                    <Tab label="Dados Pessoais" />
                    {!permissaoMestre && <Tab label="Instalações Autorizadas" />}
                </Tabs>

                <TabPanel value={tabIndex} index={0}>
                    <Box display="flex" flexDirection="column" gap={2} maxWidth="700px">
                        <FormControlLabel
                            control={<Switch checked={status === 1} onChange={(e) => setStatus(e.target.checked ? 1 : 0)} color="primary" />}
                            label={status === 1 ? "Cadastro Ativo" : "Cadastro Bloqueado"}
                        />

                        <TextField label="Nome Completo" variant="outlined" fullWidth value={nome} onChange={(e) => setNome(e.target.value)} />
                        <TextField label="CPF" variant="outlined" fullWidth value={cpf} onChange={(e) => setCpf(e.target.value)} />
                        <TextField label="Endereço" variant="outlined" fullWidth value={endereco} onChange={(e) => setEndereco(e.target.value)} />
                        
                        <FormControlLabel
                            control={<Switch checked={permissaoMestre} onChange={(e) => setPermissaoMestre(e.target.checked)} color="primary" />}
                            label="Permissão Mestre (Acesso a TODAS as instalações restrito apenas pelo horário)"
                            style={{ marginTop: 10, marginBottom: 10 }}
                        />
                        
                        {permissaoMestre && (
                            <Box mt={2}>
                                <Typography variant="h6">Horários Globais da Permissão Mestre</Typography>
                                {renderGridDias(diasSemana, setDiasSemana)}
                            </Box>
                        )}
                        
                        <Box mt={2}>
                            <Typography variant="body2" color="textSecondary" gutterBottom>Foto Facial</Typography>
                            <input
                                accept="image/*"
                                style={{ display: 'none' }}
                                id="raised-button-file"
                                type="file"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const reader = new FileReader();
                                        reader.onloadend = () => {
                                            setFotoBase64(reader.result);
                                        };
                                        reader.readAsDataURL(file);
                                    }
                                }}
                            />
                            <label htmlFor="raised-button-file">
                                <Button variant="outlined" component="span" color="primary">Alterar Imagem</Button>
                            </label>
                            {fotoBase64 && (
                                <Box mt={2}>
                                    <img src={fotoBase64} alt="Preview" style={{ width: '150px', borderRadius: '8px' }} />
                                </Box>
                            )}
                        </Box>
                        
                        <Box mt={3} mb={5}>
                            <ColorButtonBlue variant="contained" onClick={handleSalvarPessoa} disabled={loading}>
                                Salvar Alterações
                            </ColorButtonBlue>
                            <Button style={{ marginLeft: 10 }} variant="outlined" onClick={() => history.push('/gestao/administracao/pessoasinteresse/listar')}>
                                Voltar
                            </Button>
                        </Box>
                    </Box>
                </TabPanel>

                <TabPanel value={tabIndex} index={1}>
                    <Box mb={2}>
                        <ColorButtonBlue variant="contained" onClick={openAddModal}>
                            Adicionar Instalações
                        </ColorButtonBlue>
                    </Box>
                    
                    <MaterialReactTable
                        columns={colunasVinculos}
                        data={vinculos}
                        enableColumnActions={false}
                        enableFilters={false}
                        enablePagination={false}
                    />
                </TabPanel>
            </Grid>

            {/* Modal Add Batch */}
            <Dialog open={modalAddOpen} onClose={() => setModalAddOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Adicionar Instalações</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <Autocomplete
                            multiple
                            id="instalacoes-autocomplete"
                            options={todasInstalacoes}
                            getOptionLabel={(option) => option.nome_fantasia || option.nome_empresarial || option.nome || String(option.id_instalacao)}
                            getOptionSelected={(option, value) => option.id_instalacao === value.id_instalacao}
                            value={instalacoesSelecionadas}
                            onChange={(event, newValue) => {
                                setInstalacoesSelecionadas(newValue);
                            }}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                    handlePesquisarInstalacoes(newInputValue);
                                }
                            }}
                            filterOptions={(x) => x}
                            loading={loadingInstalacoes}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label="Instalações Vinculadas (Acesso)"
                                    placeholder="Digite 4 ou mais letras da instalação..."
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <React.Fragment>
                                                {loadingInstalacoes ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </React.Fragment>
                                        ),
                                    }}
                                />
                            )}
                        />
                        <Typography variant="h6" style={{marginTop: 10}}>Configurar Horários (aplicará a todas selecionadas)</Typography>
                        {renderGridDias(diasModal, setDiasModal)}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setModalAddOpen(false)}>Cancelar</Button>
                    <ColorButtonBlue variant="contained" onClick={handleAdicionarLote}>Adicionar</ColorButtonBlue>
                </DialogActions>
            </Dialog>

            {/* Modal Edit Connection */}
            <Dialog open={modalEditOpen} onClose={() => setModalEditOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Editar Horários: {vinculoEditando?.instalacao?.nome_fantasia || vinculoEditando?.instalacao?.nome}</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" gap={2} mt={1}>
                        <Typography variant="h6">Configurar Horários Específicos</Typography>
                        {renderGridDias(diasModal, setDiasModal)}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setModalEditOpen(false)}>Cancelar</Button>
                    <ColorButtonBlue variant="contained" onClick={handleSalvarEdicaoVinculo}>Salvar Horários</ColorButtonBlue>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}
